export function parseAmountValue(value: string | number | null | undefined): number {
  if (value == null) return 0;
  if (typeof value === 'number') return Math.round(value);
  const cleaned = String(value).replace(/[^\d.,-]/g, '').replace(',', '.');
  const parsed = Number.parseFloat(cleaned);
  return Number.isFinite(parsed) ? Math.round(parsed) : 0;
}

export function formatAmount(n: number): string {
  return String(Math.round(n));
}
